import React from 'react';
import Skeleton from 'react-loading-skeleton';
import {
  Row, Col,
} from 'reactstrap';

import LocaleService from '@services/LocaleService';

import '../../ReferralMessagesStyle.scss';

const i18n = LocaleService.getTranslations('messages');

const ReferralDetailsSkeleton = () => (
  <>
    <div className="referral-details-container">
      <Row className="mb-3">
        <Col xs={4}>
          <Skeleton
            borderRadius={100}
            baseColor="var(--skeleton-base)"
            highlightColor="var(--skeleton-highlight)"
            height={20}
            width="100%"
          />
        </Col>
        <Col xs={8} className="text-end">
          <Skeleton
            borderRadius={100}
            baseColor="var(--skeleton-base)"
            highlightColor="var(--skeleton-highlight)"
            height={20}
            width="100%"
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col xs={4}>
          <Skeleton
            borderRadius={100}
            baseColor="var(--skeleton-base)"
            highlightColor="var(--skeleton-highlight)"
            height={20}
            width="100%"
          />
        </Col>
        <Col xs={8} className="text-end">
          <Skeleton
            borderRadius={100}
            baseColor="var(--skeleton-base)"
            highlightColor="var(--skeleton-highlight)"
            height={20}
            width="100%"
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col xs={4}>
          <Skeleton
            borderRadius={100}
            baseColor="var(--skeleton-base)"
            highlightColor="var(--skeleton-highlight)"
            height={20}
            width="100%"
          />
        </Col>
        <Col xs={8} className="text-end">
          <Skeleton
            borderRadius={100}
            baseColor="var(--skeleton-base)"
            highlightColor="var(--skeleton-highlight)"
            height={20}
            width="100%"
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col xs={4}>
          <Skeleton
            borderRadius={100}
            baseColor="var(--skeleton-base)"
            highlightColor="var(--skeleton-highlight)"
            height={20}
            width="100%"
          />
        </Col>
        <Col xs={8} className="text-end">
          <Skeleton
            borderRadius={100}
            baseColor="var(--skeleton-base)"
            highlightColor="var(--skeleton-highlight)"
            height={20}
            width="100%"
          />
        </Col>
      </Row>
    </div>
    <div className="referral-details-container">
      <div className="referral-details-label mb-3">
        {i18n.referralDetails.patientHistory.title}
      </div>
      <Row className="mb-3">
        <Col xs={4}>
          <Skeleton
            borderRadius={100}
            baseColor="var(--skeleton-base)"
            highlightColor="var(--skeleton-highlight)"
            height={20}
            width="100%"
          />
        </Col>
        <Col xs={8} className="text-end">
          <Skeleton
            borderRadius={100}
            baseColor="var(--skeleton-base)"
            highlightColor="var(--skeleton-highlight)"
            height={20}
            width="100%"
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col xs={4}>
          <Skeleton
            borderRadius={100}
            baseColor="var(--skeleton-base)"
            highlightColor="var(--skeleton-highlight)"
            height={20}
            width="100%"
          />
        </Col>
        <Col xs={8} className="text-end">
          <Skeleton
            borderRadius={100}
            baseColor="var(--skeleton-base)"
            highlightColor="var(--skeleton-highlight)"
            height={20}
            width="100%"
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col xs={4}>
          <Skeleton
            borderRadius={100}
            baseColor="var(--skeleton-base)"
            highlightColor="var(--skeleton-highlight)"
            height={20}
            width="100%"
          />
        </Col>
        <Col xs={8} className="text-end">
          <Skeleton
            borderRadius={100}
            baseColor="var(--skeleton-base)"
            highlightColor="var(--skeleton-highlight)"
            height={20}
            width="100%"
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col xs={4}>
          <Skeleton
            borderRadius={100}
            baseColor="var(--skeleton-base)"
            highlightColor="var(--skeleton-highlight)"
            height={20}
            width="100%"
          />
        </Col>
        <Col xs={8} className="text-end">
          <Skeleton
            borderRadius={100}
            baseColor="var(--skeleton-base)"
            highlightColor="var(--skeleton-highlight)"
            height={20}
            width="100%"
          />
        </Col>
      </Row>
    </div>
    <div className="referral-details-container">
      <div className="referral-details-label mb-3">
        {i18n.referralDetails.reasonForReferral}
      </div>
      <Row className="mb-3">
        <Col>
          <Skeleton
            borderRadius={10}
            baseColor="var(--skeleton-base)"
            highlightColor="var(--skeleton-highlight)"
            height={150}
            width="100%"
          />
        </Col>
      </Row>
      <div className="referral-details-label mb-3">
        {i18n.referralDetails.specialtiesServices}
      </div>
      <Row className="mb-3">
        <Col xs={4}>
          <Skeleton
            borderRadius={100}
            baseColor="var(--skeleton-base)"
            highlightColor="var(--skeleton-highlight)"
            height={20}
            width="100%"
          />
        </Col>
        <Col xs={8} className="text-end">
          <Skeleton
            borderRadius={100}
            baseColor="var(--skeleton-base)"
            highlightColor="var(--skeleton-highlight)"
            height={20}
            width="100%"
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col xs={4}>
          <Skeleton
            borderRadius={100}
            baseColor="var(--skeleton-base)"
            highlightColor="var(--skeleton-highlight)"
            height={20}
            width="100%"
          />
        </Col>
        <Col xs={8} className="text-end">
          <Skeleton
            borderRadius={100}
            baseColor="var(--skeleton-base)"
            highlightColor="var(--skeleton-highlight)"
            height={20}
            width="100%"
          />
        </Col>
      </Row>
    </div>
    <div className="referral-details-container referral-details-container-no-border">
      <Row className="mb-3">
        <Col xs={6}>
          <div className="referral-details-label mb-3">
            {i18n.referralDetails.attachments.title}
          </div>
        </Col>
        <Col xs={6} className="text-end">
          <Skeleton
            borderRadius={100}
            baseColor="var(--skeleton-base)"
            highlightColor="var(--skeleton-highlight)"
            height={20}
            width="100%"
          />
        </Col>
      </Row>
      <Row className="attachment-row-style attachment-row-border mb-1">
        <Col>
          <Skeleton
            borderRadius={10}
            baseColor="var(--skeleton-base)"
            highlightColor="var(--skeleton-highlight)"
            height={60}
            width="100%"
          />
        </Col>
      </Row>
      <Row className="attachment-row-style">
        <Col>
          <Skeleton
            borderRadius={10}
            baseColor="var(--skeleton-base)"
            highlightColor="var(--skeleton-highlight)"
            height={60}
            width="100%"
          />
        </Col>
      </Row>
    </div>
  </>
);

export default ReferralDetailsSkeleton;
